export default __webpack_public_path__ + "static/media/frogreelin.42039000.gif";